export const colors = {
  'red': '#fa4003',
  'blue': '#267dde',
  'yellow': '#ffed00',
  'green': '#45c905'
}

export function toUri (path) {
  return path.replace(window.SITE_BASE, '').replace(/^\/+/g, '')
}